import $ from 'jquery';

$(document).ready(function() {
    let text = "";
    $(document).on('click', '.js-filter-item', function() {
        $(this).parents('.b-container').find('.js-filter-all-events').removeClass('active');
        $(this).parents('.b-container').find('.js-filter-all-media').removeClass('active');
        $(this).toggleClass('active');
    });
    $(document).on('click', '.js-filter-all-events', function() {
    	$('.b-museum-events .js-filter-item').removeClass('active');
    	$(this).toggleClass('active');
    });
    $(document).on('click', '.js-filter-all-media', function() {
    	$('.b-museum-media .js-filter-item').removeClass('active');
    	$(this).toggleClass('active');
    });
    $(document).on('click', '.js-filter-mobile', function() {
        $('.js-filter-inner-mobile-date').removeClass('show');
        $('.js-filter-inner-mobile-inner').removeClass('show');
        $('.js-filter-inner-mobile').addClass('show');
        $('body').addClass('is-modal-open');
    });
    $(document).on('click', '.js-filter-mobile-inner', function() {
        if ($(window).width() < 1024) {
            $('.js-filter-inner-mobile').removeClass('show');
            $('.js-filter-inner-mobile-inner').addClass('show');
        }
    });
    $(document).on('click', '.js-museums-mobile-sort', function() {
        if ($(window).width() < 1024) {
            $('.js-filter-inner-mobile-sort').addClass('show');
            $('body').addClass('is-modal-open');
        }
    });
    $(document).on('click', '.js-filter-mobile-close', function() {
        $('.js-filter-inner-mobile').removeClass('show');
        $('.js-filter-inner-mobile-sort').removeClass('show');
        $('body').removeClass('is-modal-open');
    });
    $(document).on('click', '.js-filter-mobile-date-button', function() {
        text = "с 07.05.2018 до 09.05.2018";
        $('.b-calendar-filter__item--date span').text(text);
        $('.b-calendar-filter__item--date').addClass('date');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/one-museum/museum-filter.js